/**
 * Copyright (c) 2023-present.
 * This source code is copied from https://github.com/justinmahar/react-social-media-embed
 */
import classNames from 'classnames'
import * as React from 'react'
import { SkeletonBox, Box } from 'chemistry'
import { EmbedStyle } from './embedStyle.js'

const borderRadius = 8

export default function LinkedInEmbed({
  url,
  postUrl,
  height = 600,
  width = 540,
  placeholderDisabled = false,
  ...divProps
}) {
  const [ready, setReady] = React.useState(false)
  const frameRef = React.useRef(null)

  React.useEffect(() => {
    frameRef.current.src = '//www.linkedin.com/embed/feed/update/urn:li:share:6898694772484112384'
  }, [])

  return (
    <Box
      {...divProps}
      className={classNames('rsme-embed rsme-linkedin-embed', divProps.className)}
      sx={{
        overflow: 'hidden',
        height: `${height}px`,
        width: '100%',
        maxWidth: `${width}px`,
        m: '0 auto',
        borderRadius,
        ...divProps.style
      }}
    >
      <EmbedStyle />
      <iframe
        ref={frameRef}
        className={classNames('linkedin-post', !ready && 'rsme-d-none')}
        width='100%'
        height={!ready ? 0 : `${height}px`}
        onLoad={() => setReady(true)}
        title='linkedIn'
        style={{ border: 'none' }}
      />
      {!ready && !placeholderDisabled && <SkeletonBox url={url} height={height} />}
    </Box>
  )
}
